import React from "react";
import { Input, Toggle } from "rsuite";
import { Field } from "../../../../../types/TenantInterfaces";
import { FormBuilder } from "../../../../../types/FormBuilderInterfaces";
import { Prefill } from "../../../../../types/GlobalInterfaces";
import { getPrefillValue } from "../../../../../utils/QuickCreateUtils";
import InputFormatter from "../../../../Records/Formatters/InputFormatter";

interface Props {
  form: FormBuilder;
  setForm: (value: any, key: string) => void;
  field: Field;
  prefill?: Prefill;
}

interface HandleChange {
  settingsField: string;
  val: string | boolean;
  fieldVal?: any;
}

const FieldSettings = ({ form, setForm, field, prefill }: Props) => {
  const handleChange = ({ settingsField, val, fieldVal }: HandleChange) => {
    const fieldValue = getPrefillValue({
      prefill,
      fieldAPIName: field.APIName,
    });

    const newFields = {
      ...form.Fields,
      [field.APIName]: {
        ...form.Fields?.[field.APIName],
        Settings: {
          ...form.Fields?.[field.APIName].Settings,
          [settingsField]: val,
        },
        Value: fieldVal
          ? val
            ? fieldValue
            : ""
          : form.Fields?.[field.APIName].Value
          ? form.Fields?.[field.APIName].Value
          : "",
      },
    };

    setForm(newFields, "Fields");
  };

  return (
    <div className="d-flex flex-column">
      <label className="mt-3 text-xs">Label</label>
      <Input
        size="sm"
        onChange={(val: string) =>
          handleChange({ settingsField: "Label", val })
        }
        value={form.Fields?.[field.APIName].Settings?.Label}
      />
      <label className="mt-3 text-xs">Placeholder</label>
      <Input
        size="sm"
        onChange={(val: string) =>
          handleChange({ settingsField: "Placeholder", val })
        }
        value={form.Fields?.[field.APIName].Settings?.Placeholder}
      />
      <label className="mt-3 text-xs">Default</label>
      {/* @ts-ignore */}
      <InputFormatter
        size="sm"
        module={{ APIName: form.ModuleAPIName }}
        field={field}
        value={form.Fields?.[field.APIName].Settings?.Default}
        // @ts-ignore
        onChange={(_: any, val: any) =>
          handleChange({ settingsField: "Default", val })
        }
      />
      <div className="d-flex justify-content-between mt-4">
        <div className="d-flex align-items-center">
          <label className="text-xs mr-3">Required</label>
          <Toggle
            onChange={(val: boolean) =>
              handleChange({ settingsField: "Required", val })
            }
            checked={form.Fields?.[field.APIName].Settings?.Required}
          />
        </div>
        {/* <div className="d-flex align-items-center">
          <label className="text-xs mr-3">Match</label>
          <Toggle
            onChange={(val: boolean) =>
              handleChange({ settingsField: "Match", val, fieldVal: true })
            }
            checked={form.Fields?.[field.APIName].Settings?.Match}
            disabled={!form.Prefill}
          />
        </div> */}
      </div>
    </div>
  );
};

export default FieldSettings;
